import { Reveal } from "./Reveal";
import { useLanguage } from "@/i18n";

export default function SectorGroups({ testid = "sector-groups" }) {
    const { t } = useLanguage();

    return (
        <div data-testid={testid}>
            <Reveal>
                <p className="mb-6 font-mono text-xs font-medium uppercase tracking-[0.3em] text-sky-400">
                    {t.sectorGroups.eyebrow}
                </p>
            </Reveal>
            <div className="grid gap-px border border-navy-600 bg-navy-600 md:grid-cols-3">
                {t.sectorGroups.groups.map((g, gi) => (
                    <Reveal key={g.title} delay={gi * 0.06} className="h-full">
                        <div
                            data-testid={`${testid}-group-${gi + 1}`}
                            className="flex h-full flex-col bg-navy-950 p-6 lg:p-8"
                        >
                            <h3 className="font-display text-lg font-semibold tracking-tight text-slate-50">
                                {g.title}
                            </h3>
                            <div className="mt-5 flex flex-wrap gap-2">
                                {g.items.map((item) => (
                                    <span
                                        key={item}
                                        className="border border-navy-600 px-3 py-1 font-mono text-[10px] uppercase tracking-widest text-slate-400"
                                    >
                                        {item}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    );
}
